// import MixinScope from './MixinScope.js'
import MixinEnum from './MixinEnum.js'
import MixinUtil from './MixinUtil.js'

export default {
    install(Vue) {
        Vue.mixin(MixinEnum)
        Vue.mixin(MixinUtil)
    },
};
